<template>
  <div id="app">
    <b-loading :is-full-page="true" :active.sync="isLoading" :canCancel="true"></b-loading>
    <router-view/>
  </div>
</template>

<script>
  /*window.twttr = (function(d, s, id) {
    var js, fjs = d.getElementsByTagName(s)[0],
      t = window.twttr || {};
    if (d.getElementById(id)) return t;
    js = d.createElement(s);
    js.id = id;
    js.src = "https://platform.twitter.com/widgets.js";
    fjs.parentNode.insertBefore(js, fjs);
    t._e = [];
    t.ready = function(f) {
      t._e.push(f);
    };
    return t;
  }(document, "script", "twitter-wjs"));

  (function(d, s, id) {
    var js, fjs = d.getElementsByTagName(s)[0];
    if (d.getElementById(id)) return;
    js = d.createElement(s); js.id = id;
    js.src = "https://connect.facebook.net/en_US/sdk.js#xfbml=1&version=v3.0";
    fjs.parentNode.insertBefore(js, fjs);
  }(document, 'script', 'facebook-jssdk'));*/

export default {
  name: 'app',
  data () {
    return {
      isLoading:false
    }
  },

  methods: {
    showSpinner() {
      this.isLoading=false
    },
    hideSpinner() {
      this.isLoading=false

    }
  },

  created(){
    this.$http.interceptors.request.use(
      conf => {
        this.showSpinner()
        return conf;
      },
      error => {
        this.hideSpinner()
        return Promise.reject(error);
      }
    );
    this.$http.interceptors.response.use(
      response => {
        this.hideSpinner()
        return response;
      },
      error => {

        this.hideSpinner()

        if (!error.response) {
          this.$buefy.toast.open({
            duration: 5000,
            message: `Error al conectarse al servidor`,
            position: 'is-top',
            type: 'is-danger'
          })
        }
        else{
          console.log(error.response)
          if(error.response.status=='401')
          {
            this.$buefy.toast.open({
              duration: 5000,
              message: `Debes iniciar sesion`,
              position: 'is-top',
              type: 'is-danger'
            })
            return
          }
        }
        return Promise.reject(error);
      }
    );

  }
}
</script>

<style lang="scss">
  @import "./assets/scss/main.scss";
</style>



// WEBPACK FOOTER //
// src/App.vue